/**
 * Route definitions for the public (auth) app.
 *
 * These routes are served from the root path (`/`) and handle
 * all unauthenticated flows: login, registration, password reset,
 * email verification, two-factor, third-party app authorization, sign-out,
 * and the Microsoft sign-in popup callback.
 */

import Login from '../pageComponents/auth/Login.svelte';
import Register from '../pageComponents/auth/Register.svelte';
import ForgotPassword from '../pageComponents/auth/ForgotPassword.svelte';
import ResetPassword from '../pageComponents/auth/ResetPassword.svelte';
import VerifyAccount from '../pageComponents/auth/VerifyAccount.svelte';
import TwoFactor from '../pageComponents/auth/TwoFactor.svelte';
import Authorize from '../pageComponents/auth/Authorize.svelte';
import Logout from '../pageComponents/auth/Logout.svelte';
import MicrosoftCallback from '../pageComponents/auth/MicrosoftCallback.svelte';
import Handle404 from '../pageComponents/404.svelte';

/** Public route map — URL patterns to auth page components. */
export default {
	'/login': Login,
	'/register': Register,
	'/forgot-password': ForgotPassword,
	'/reset-password': ResetPassword,
	'/verify-account': VerifyAccount,
	'/two-factor': TwoFactor,
	'/authorize': Authorize,
	'/logout': Logout,

	/* Landing page for the Microsoft sign-in popup — not user-navigable. */
	'/auth/microsoft/callback': MicrosoftCallback,

	// Catch-all
	'*': Handle404
};
